export { default } from './TitleText.js';
